import {
  Text,
  HStack,
  TruncateTextWithTooltip,
  type TextProps,
} from '@frontend/components';

export interface TruncatedPartLabelProps {
  partNumber?: string;
  revision?: string;
  filename?: string;
  size?: TextProps['size'];
  color?: TextProps['color'];
}

export const TruncatedPartLabel = ({
  partNumber,
  revision,
  filename,
  size = 'lg',
  color = 'feature.primary',
}: TruncatedPartLabelProps) => {
  if (partNumber || revision) {
    return (
      <HStack spacing={1.5} maxWidth="100%" minWidth={0} overflow="hidden">
        <TruncateTextWithTooltip
          color={color}
          text={partNumber || '--'}
          displayText={partNumber || '--'}
          size={size}
          alignSelf="center"
          fontFamily="data"
          minWidth={0}
          maxWidth="100%"
          tooltipProps={{
            label: partNumber ?? '--',
          }}
        />
        <Text
          size="md"
          color="feature.secondary"
          fontFamily="data"
          fontWeight="heavy"
          flexShrink={0}
        >
          REV
        </Text>
        <TruncateTextWithTooltip
          text={revision || '--'}
          displayText={revision || '--'}
          size={size}
          color={revision ? color : 'feature.placeholder'}
          fontFamily="data"
          minWidth={0}
          maxWidth="4ch"
          flexShrink={0}
        />
      </HStack>
    );
  }

  return (
    <TruncateTextWithTooltip
      text={filename || '--'}
      displayText={filename || '--'}
      size={size}
      color={color}
      fontFamily="data"
      minWidth={0}
    />
  );
};
